export default __webpack_public_path__ + "static/media/logo.615c264e.png";